import { throttle } from 'throttle-debounce';
import { SETTINGS, BREAKPOINTS, CLASSES, ARIAS } from '../../utils/constants';
import { initSearch,initAdvancedCommerceSearch } from './search';

const initHeader = () => {
  const headerEl = document.querySelector('[data-header]');
  if (!headerEl) return;
  const desktopMediaQuery = window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP_LARGE}px)`);
  const announcementBarEl = document.querySelector('[data-announcement-bar]');
  const navToggle = headerEl.querySelector('[data-nav-toggle]');
  const menuIconEl = navToggle.querySelector('[data-menu]');
  const menuCloseIconEl = navToggle.querySelector('[data-menu-close]');
  const searchEl = headerEl.querySelector('[data-predictive-search]');
  const navigationEl = headerEl.querySelector('[data-navigation]');
  const navigationWrapperEl = navigationEl.querySelector('[data-navigation-wrapper]');
  const navMenuEls = navigationEl.querySelectorAll('[data-navigation-menu]');

  const mainEl = document.querySelector('main');

  let lastScrollY = window.scrollY;
  let isScrollHandlerAttached = false;

  const getStickyStatus = () => {
    if (!announcementBarEl) return;
    const announcementBarContainer = announcementBarEl.parentElement;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          headerEl.removeAttribute('data-sticky-active');
        } else {
          headerEl.setAttribute('data-sticky-active', 'true');
        }
      },
      { threshold: [0] }
    );
    if (announcementBarContainer) observer.observe(announcementBarContainer);
  };

  const hideShowStickyEls = () => {
    if (!searchEl) return;
    const currentScrollY = window.scrollY;
    const deltaY = currentScrollY - lastScrollY;
    if (Math.abs(deltaY) < SETTINGS.MOBILE_HEADER_STICKY_SCROLL_THRESHOLD) return;
    if (deltaY > 0) {
      searchEl.classList.add('hidden');
    }
    lastScrollY = currentScrollY;
  };

  const throttledHideShowStickyEls = searchEl ? throttle(SETTINGS.THROTTLE_DELAY_SMALL, hideShowStickyEls) : null;
  const setStickyScrollListener = (breakpoint) => {
    if (throttledHideShowStickyEls === null) return;
    if (breakpoint.matches) {
      if (isScrollHandlerAttached) {
        window.removeEventListener('scroll', throttledHideShowStickyEls);
        isScrollHandlerAttached = false;
      }
      if (searchEl) searchEl.classList.remove('hidden');
    } else {
      if (!isScrollHandlerAttached) {
        window.addEventListener('scroll', throttledHideShowStickyEls);
        isScrollHandlerAttached = true;
      }
    }
  };

  const closeSubNav = (subNav, level, closeBtn, handler) => {
    subNav.classList.remove(CLASSES.TRANSLATE_X_0);
    const triggerLink = subNav.previousElementSibling;
    if (triggerLink && triggerLink.hasAttribute(ARIAS.EXPANDED)) {
      triggerLink.setAttribute(ARIAS.EXPANDED, 'false');
    }
    if (level === '2') {
      navigationWrapperEl.classList.remove(CLASSES.OVERFLOW_HIDDEN);
    } else {
      const parentMenu = subNav.closest('[data-navigation-menu="2"]');
      subNav.classList.remove(CLASSES.SCROLLABLE);
      if (parentMenu) {
        parentMenu.classList.remove(CLASSES.OVERFLOW_HIDDEN);
      }
    }
    closeBtn.removeEventListener('click', handler);
  };

  const openSubNav = (subNav, level) => {
    if (!subNav) return;
    subNav.classList.add(CLASSES.TRANSLATE_X_0);
    navigationWrapperEl.classList.add(CLASSES.OVERFLOW_HIDDEN);
    if (level === '3') {
      const parentMenu = subNav.closest('[data-navigation-menu="2"]');
      if (parentMenu) {
        parentMenu.scrollTop = 0;
        subNav.classList.add(CLASSES.SCROLLABLE);
        parentMenu.classList.add(CLASSES.OVERFLOW_HIDDEN);
      }
    }

    const closeBtn = subNav.querySelector('[data-navigation-close]');
    if (closeBtn) {
      const handleClose = () => closeSubNav(subNav, level, closeBtn, handleClose);
      closeBtn.addEventListener('click', handleClose);
    }
  };

  const bindNavigationLinks = (links) => {
    links.forEach(link => {

      // Use capture phase to run BEFORE other handlers
      link.addEventListener('click', (evt) => {
        
        // Check for target="_blank" FIRST, before any other logic
        const targetAttr = link.getAttribute('target');
        if (targetAttr === '_blank') {
          // Allow the link to open in new tab - stop any other handlers from interfering
          evt.stopImmediatePropagation();
          return;
        }

        // Only handle submenu logic on mobile
        if (desktopMediaQuery.matches) return;

        // Only prevent default and open submenu for links with data-open-menu
        if (!link.hasAttribute('data-open-menu')) return;

        evt.preventDefault();

        const subNav = link.nextElementSibling;
        if (!subNav || !subNav.dataset.navigationMenu) return;

        link.setAttribute(ARIAS.EXPANDED, 'true');
        openSubNav(subNav, subNav.dataset.navigationMenu);
        
      }, { capture: true }); // Use capture phase to run first
    });
  };

  const resetNavigation = () => {
    navMenuEls.forEach(menu => {
      menu.classList.remove(CLASSES.TRANSLATE_X_0);
      menu.scrollTop = 0;
    });
    navigationEl.querySelectorAll(`[${ARIAS.EXPANDED}]`).forEach(el => {
      el.setAttribute(ARIAS.EXPANDED, 'false');
    });
    navigationEl.scrollTop = 0;
    navigationWrapperEl.classList.remove(CLASSES.OVERFLOW_HIDDEN);
  };

  navToggle.addEventListener('click', () => {
    const isOpen = navToggle.classList.toggle('nav-open');
    navToggle.setAttribute(ARIAS.EXPANDED, isOpen);
    navigationEl.classList.toggle(CLASSES.TRANSLATE_X_0);
    if (menuIconEl) menuIconEl.classList.toggle('hidden', isOpen);
    if (menuCloseIconEl) menuCloseIconEl.classList.toggle('hidden', !isOpen);
    if (isOpen) resetNavigation();
  });

  // Bind ALL navigation links (not just ones with data attributes)
  const allNavLinks = navigationEl.querySelectorAll('a.navigation-item');
  bindNavigationLinks(allNavLinks);

  getStickyStatus();
  setStickyScrollListener(desktopMediaQuery);
  desktopMediaQuery.addEventListener('change', () => setStickyScrollListener(desktopMediaQuery));
  initSearch();
  initAdvancedCommerceSearch();
};

export default initHeader;
